// extracted by mini-css-extract-plugin
module.exports = {"container":"infoCard_container__3UMRE","title":"infoCard_title__T8MXM","description":"infoCard_description__2V_zZ"};